import { useRouteMatch } from 'react-router';
import ContentDetails from './content-details';

export function UgcPreviewView() {
  const { params } = useRouteMatch<{ id: string }>();
  return <ContentDetails contentId={Number(params.id)} isUgcPreview />;
}
